<template>
  <ul class="user-account-container menu-list">
    <li class="navbar-item has-dropdown is-hoverable">
      <a class="navbar-link is-arrowless">
        <font-awesome-icon icon="cog"></font-awesome-icon>
      </a>

      <div class="navbar-dropdown is-boxed">
        <!-- Scrollable workspace list -->
        <div v-if="!isPlatformAdmin || !isPlatformAdminRoute" class="workspace-scroll-container">
          <a
            class="navbar-item"
            v-for="workspace in workspaces"
            :key="workspace.id"
            @click="selectWorkspace(workspace)"
          >
            <span>{{ workspace.name }}</span>
            <span class="icon is-small" v-if="workspace.id === currentWorkspace.id">
              <font-awesome-icon icon="check"></font-awesome-icon>
            </span>
          </a>
        </div>
        <!-- Fixed footer -->
        <div class="dropdown-footer">
          <a v-if="isPlatformAdmin && !isPlatformAdminRoute" class="navbar-item" @click="goToPlatformAdmin">
            <span>Switch to Platform Admin</span>
          </a>

          <a v-if="isPlatformAdmin && isPlatformAdminRoute" class="navbar-item" @click="goToRoot">
            <span>Exit Platform Admin</span>
          </a>

          <a v-if="!isPlatformAdmin || !isPlatformAdminRoute" class="navbar-item" @click="goToSettings">
            <span>Manage Workspace Settings</span>
          </a>

          <hr class="navbar-divider" />
          <a class="navbar-item" @click="logout"> Logout </a>
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { CHANGE_WORKSPACE } from '@/store/app/actionTypes';
import { useAuth } from '@/authentication/useAuth';

// Vuex store
const store = useStore();

// Router and Route
const router = useRouter();
const { logout, isPlatformAdmin } = useAuth();

// Computed properties (Vuex getters)
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const workspaces = computed(() => store.getters.workspaces);

function selectWorkspace(workspace: WorkspaceViewModel) {
  store.dispatch(CHANGE_WORKSPACE, workspace); // Fixed from store.actions
}

function goToSettings() {
  router.push({ name: 'general-settings' });
}

function goToPlatformAdmin() {
  router.push({ name: 'platform-admin-workspaces-list' });
}

function goToRoot() {
  router.push({ name: 'root' });
}

const route = useRoute();
const activeRouteName = computed(() => String(route?.name || ''));
const isPlatformAdminRoute = computed(() => activeRouteName.value.startsWith('platform-admin'));
</script>
